module.exports = new __parcel__URL__("product_4.3f5cfa68.png").toString();